module.exports = __webpack_public_path__ + "img/generateExam.d896ddbf.svg";